import SEOMeta from '@/components/feature/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from '@/pages/home/components/HeroBanner';
import CategoryNav from '@/pages/home/components/CategoryNav';
import FeaturedAnime from '@/pages/home/components/FeaturedAnime';
import TopRanking from '@/pages/home/components/TopRanking';
import LatestArticles from '@/pages/home/components/LatestArticles';
import FAQSection from '@/pages/home/components/FAQSection';
import { siteConfig } from '@/mocks/animeData';

const homepageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteConfig.name,
  url: siteConfig.url,
  description: siteConfig.description,
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteConfig.url}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title={`${siteConfig.name}｜${siteConfig.keywords.split(',').slice(0, 2).join('·')}`}
        description={siteConfig.description}
        keywords={siteConfig.keywords}
        canonicalUrl={siteConfig.url}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroBanner siteConfig={siteConfig} />
        <CategoryNav />
        <FeaturedAnime />
        <TopRanking />
        <LatestArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}